import { OnboardingCustomRequestType } from 'further-types/lp/onboarding-custom-request';
import { isMongoId } from '../../helpers';
import { z } from 'zod';

export const OnboardingCustomRequestSchema = z.object({
  title: z.string().min(1, { message: 'Title is required' }),
  description: z.string().optional(),
  documents: z.array(
    z.object({
      name: z.string().min(1, { message: 'Name is required' }),
      path: z.string().min(1, { message: 'Path is required' }),
    }),
  ),
  type: z.nativeEnum(OnboardingCustomRequestType),
  isRequired: z.boolean(),
});

export const AddTaxCustomRequestInput = OnboardingCustomRequestSchema;

export const UpdateTaxCustomRequestInput = OnboardingCustomRequestSchema.extend(
  {
    id: z.string().refine(isMongoId()),
  },
);

export const AddKybCustomRequestInput = OnboardingCustomRequestSchema;

export const UpdateKybCustomRequestInput = OnboardingCustomRequestSchema.extend(
  {
    id: z.string().refine(isMongoId()),
  },
);

export const AddKycCustomRequestInput = OnboardingCustomRequestSchema;

export const UpdateKycCustomRequestInput = OnboardingCustomRequestSchema.extend(
  {
    id: z.string().refine(isMongoId()),
  },
);

export const DeleteOnboardingCustomRequestInput = z.object({
  id: z.string().refine(isMongoId()),
});
